import classes from './SchedulingSettingsForm.module.css';

interface SectionHeaderProps {
  title: string;
  description?: string;
}

export const SectionHeader = ({ title, description }: SectionHeaderProps) => {
  if (description) {
    return (
      <div className={classes.sectionHeader}>
        <div className={classes.sectionTitle}>{title}</div>
        <div className={classes.sectionDescription}>{description}</div>
      </div>
    );
  }

  return <div className={classes.sectionTitle}>{title}</div>;
};
